import React, { Component } from 'react';
import cx from 'classnames';
import moment from 'moment';
import { replaceBucketKeysWithUrls } from '@shootsta/client-aws-s3';
import { Image, Icon, ToolTip, Text, FeatureToolTip } from '../../../ui-kit';
import '../styles/_racetrack.scss';
























const createdAt = moment.utc().startOf('month').toISOString();
const ICON_WIDTH = 39;

export default class Racetrack extends Component


{
  resizeObserver = null;

  resizeElement = React.createRef();

  state = {
    racetrackData: [],
    userData: [],
    errorFetching: false,
    trackWidth: 0,
    imageUrl: ''
  };

  componentDidMount = async () => {
    await this.fetchData();
    await this.getPreSignedImageUrl();

    this.resizeObserver = new ResizeObserver((entries) => {
      this.setState({ trackWidth: entries[0].contentRect.width });
    });

    this.resizeObserver.observe(this.resizeElement.current);
  };

  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  fetchData = async () => {
    const {
      getRacetrackAnalytics,
      organisationId
    } = this.props;

    if (getRacetrackAnalytics) {
      const { data, errors } = await getRacetrackAnalytics({
        createdAt,
        organisationId
      });

      if (
      errors ||
      !data ||
      !data.getRacetrackAnalytics ||
      !data.getRacetrackAnalytics.racetrackData ||
      !data.getRacetrackAnalytics.userData)
      {
        this.setState({ errorFetching: true });
        return;
      }

      const { racetrackData } = data.getRacetrackAnalytics;
      const { userData } = data.getRacetrackAnalytics;

      this.setState({
        racetrackData,
        userData,
        imageUrl: userData && userData.length > 0 ? userData[0].imageUrl : '',
        errorFetching: false
      });

      return;
    }

    this.setState({ errorFetching: true });
  };

  getPreSignedImageUrl = async () => {
    const { organisationId, apolloClient } = this.props;
    const { imageUrl } = this.state;

    try {
      const { imageUrl: preSignedImageUrl } = await replaceBucketKeysWithUrls({
        apiClient: apolloClient,
        data: { imageUrl },
        substitutedKeys: ['imageUrl'],
        organisationId
      });

      this.setState({ imageUrl: preSignedImageUrl });
    } catch {

      // Silently handle error
    }};

  getInitials = (userData) => {
    if (!userData || userData.length === 0) {return '--';}

    if (userData[0]) {
      const firstInitial = userData[0].firstName.charAt(0).toUpperCase();
      const secondInitial = userData[0].lastName.charAt(0).toUpperCase();
      return `${firstInitial}${secondInitial}`;
    }

    return '--';
  };

  render() {
    const {
      className = ''
    } = this.props;
    const {
      racetrackData,
      userData,
      errorFetching,
      trackWidth,
      imageUrl = ''
    } = this.state;

    const {
      createdByUserId,
      userInitials,
      totalVideosAndEngagements = 15,
      userFullName = ''
    } = userData && userData.length > 0 ? {
      createdByUserId: userData[0].createdByUserId,
      userInitials: this.getInitials(userData),
      totalVideosAndEngagements: userData[0].totalVideosAndEngagements,
      userFullName: `${userData[0].firstName} ${userData[0].lastName}`
    } : {
      createdByUserId: '',
      userInitials: this.getInitials(userData),
      totalVideosAndEngagements: 15,
      userFullName: ''
    };

    if (errorFetching) {
      return (
        <>
          There was an error fetching racetrack data...
        </>);

    }

    const smallestNumOfVideos = Math.min(...[].concat(...[racetrackData, userData]).map(
      (item) => item.totalVideosAndEngagements ? item.totalVideosAndEngagements : 0
    ));

    const largestNumOfVideos = Math.max(...[].concat(...[racetrackData, userData]).map(
      (item) => item.totalVideosAndEngagements ? item.totalVideosAndEngagements : 0
    )) - smallestNumOfVideos;

    const userRatio = (totalVideosAndEngagements - smallestNumOfVideos) / largestNumOfVideos;
    const userMarginLeft = `${userRatio * trackWidth - userRatio * ICON_WIDTH}px`;

    return (
      <div className="racetracker">
        <div className={cx('racetrack', className)}>
          <div className="racetrack__beginning">
            <Icon
              name="runningman"
              size={18} />

          </div>
          <div ref={this.resizeElement} className="racetrack__track">
            <div className="stripe" style={{ width: `${trackWidth - ICON_WIDTH / 2}px` }}>
              &nbsp;
            </div>
            {racetrackData && racetrackData.slice(0).reverse().map((item, index) => {
              if (item.createdByUserId === createdByUserId) {return <></>;}

              const ratio = (item.totalVideosAndEngagements - smallestNumOfVideos) /
              largestNumOfVideos;
              const iconMarginLeft = `${ratio * trackWidth - ratio * ICON_WIDTH}px`;

              return (
                <ToolTip
                  id={`name_tooltip_${index}`}
                  label={`${item.firstName} ${item.lastName}`}
                  place="bottom">

                  <div
                    className="racetrack__track__user-icon"
                    style={{ marginLeft: iconMarginLeft }}>

                    {this.getInitials([item])}
                  </div>
                </ToolTip>);

            })}

            <ToolTip
              id="name_tooltip_user"
              label={userFullName}
              place="bottom">

              <div className="racetrack__track__user-icon user-indicator" style={{ marginLeft: userMarginLeft }}>
                <div className="arrow-down" />
                <div className="racetrack__track__user-icon">
                  {userInitials}
                </div>
                {imageUrl &&
                <Image
                  width={35}
                  height={35}
                  imageUrl={imageUrl}
                  circular
                  placeholderText={userInitials}
                  placeholderTextSize={12} />}


              </div>
            </ToolTip>
          </div>
          <div className="racetrack__end">
            <Icon
              name="raceflag"
              size={18} />

            <FeatureToolTip>
              <Text block className="feature-tooltip__modal-content__text">
                The RaceTrack shows your position relative
                to the top 20 performing workspace
                colleagues.
              </Text>
              <Text block className="feature-tooltip__modal-content__text">
                Your position is reflective of the past 30 days &
                calculated on the number of Elevates you create plus
                the number of engagements including Splash page views,
                Video views & CTA clicks.
              </Text>
            </FeatureToolTip>
          </div>
        </div>
      </div>);

  }
}